var _defs, _path, _rect, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDatarepresentation10(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    preserveAspectRatio: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 280.85 81.11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#91181d;}.cls-2{fill:url(#linear-gradient);}.cls-3{fill:url(#linear-gradient-2);}.cls-4{fill:#fff;opacity:0.45;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 140.43,
    y1: 67.86,
    x2: 140.43,
    y2: 10.28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f4e795"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#f4b331"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#f4b331"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#f4ad31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#f48631"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#f46e31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f46531"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 140.43,
    y1: 11.96,
    x2: 140.43,
    y2: 68.57,
    xlinkHref: "#linear-gradient"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M273.67,26.29V51.86c0,10.12-16.82,18.33-37.58,18.33H44.76C24,70.19,7.18,62,7.18,51.86V26.29C7.18,16.16,24,8,44.76,8H236.09C256.85,8,273.67,16.16,273.67,26.29Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 14.03,
    y: 10.28,
    width: 252.79,
    height: 57.58,
    rx: 28.79
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M228.21,65.27H52.64c-18.11,0-32.8-7.17-32.8-16V28.88c0-8.84,14.69-16,32.8-16H228.21c18.11,0,32.8,7.16,32.8,16V49.26C261,58.1,246.32,65.27,228.21,65.27Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M51.15,22.23h-8c-2.33,0-4.23-.93-4.23-2.07s1.9-2.06,4.23-2.06h8c2.34,0,4.23.93,4.23,2.06S53.49,22.23,51.15,22.23Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M87.59,22.35H65.94c-2.34,0-4.23-.92-4.23-2.06s1.89-2.07,4.23-2.07H87.59c2.34,0,4.23.93,4.23,2.07S89.93,22.35,87.59,22.35Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatarepresentation10);
export default __webpack_public_path__ + "static/media/Data representation-10.a7f6a8528d7d032cc0d33f396dd6c606.svg";
export { ForwardRef as ReactComponent };